module.exports = __webpack_public_path__ + "img/icon-chat-empty.b77f2481.png";